angular.module('bmsApp.sm.quote').controller('SMQuoteMainCtrl',
	function ($state,
			  $scope) {

		$scope.$on('quoteIndexUpdated', function (e, quoteData) {
			$scope.quoteData = quoteData;
		});

	});